export const workOrderDefaultGridState ={
    "sideBar": {
        "visible": true,
        "position": "right",
        "openToolPanel": null,
        "toolPanels": {
            "columns": {
                "expandedGroupIds": []
            },
            "filters": {
                "expandedGroupIds": [],
                "expandedColIds": []
            }
        }
    },
    "columnVisibility": {
        "hiddenColIds": [
            "lading_uuid"
        ]
    },
    "columnSizing": {
        "columnSizingModel": [
            {
                "colId": "actions",
                "width": 100
            },
            {
                "colId": "alternate_reference",
                "width": 130
            },
            {
                "colId": "hot",
                "width": 90
            },
            {
                "colId": "lading_uuid",
                "width": 200
            },
            {
                "colId": "lading_number",
                "width": 150
            },
            {
                "colId": "pro_bill",
                "width": 100
            },
            {
                "colId": "shipper_name",
                "width": 200
            },
            {
                "colId": "consignee_name",
                "width": 200
            },
            {
                "colId": "lading_status",
                "width": 200
            },
            {
                "colId": "carrier_name",
                "width": 200
            },
            {
                "colId": "customer_name",
                "width": 200
            },
            {
                "colId": "shipper_locality",
                "width": 150
            },
            {
                "colId": "shipper_region",
                "width": 150
            },
            {
                "colId": "consignee_locality",
                "width": 150
            },
            {
                "colId": "consignee_region",
                "width": 150
            },
            {
                "colId": "load_start",
                "width": 150
            },
            {
                "colId": "load_end",
                "width": 150
            },
            {
                "colId": "trip_number",
                "width": 200
            },
            {
                "colId": "drop_trailer",
                "width": 200
            },
            {
                "colId": "partial_or_full",
                "width": 200
            },
            {
                "colId": "load_pallets",
                "width": 100
            },
            {
                "colId": "load_pieces",
                "width": 100
            },
            {
                "colId": "load_length",
                "width": 200
            },
            {
                "colId": "load_length_unit",
                "width": 200
            },
            {
                "colId": "load_weight",
                "width": 100
            },
            {
                "colId": "load_weight_actual",
                "width": 100
            },
            {
                "colId": "load_weight_unit",
                "width": 100
            },
            {
                "colId": "type_of_equipment",
                "width": 175
            },
            {
                "colId": "lading_id",
                "width": 200
            },
            {
                "colId": "drop_trailer_status",
                "width": 200
            },
            {
                "colId": "expedited",
                "width": 100
            },
            {
                "colId": "customer_po",
                "width": 200
            },
            {
                "colId": "pickup_reference_number",
                "width": 200
            },
            {
                "colId": "delivery_reference_number",
                "width": 200
            },
            {
                "colId": "booking_number",
                "width": 200
            },
            {
                "colId": "release_number",
                "width": 200
            },
            {
                "colId": "equipment_options",
                "width": 200
            },
            {
                "colId": "created",
                "width": 200
            }
        ]
    },
    "columnOrder": {
        "orderedColIds": [
            "alternate_reference",
            "hot",
            "lading_uuid",
            "lading_number",
            "pro_bill",
            "shipper_name",
            "consignee_name",
            "lading_status",
            "carrier_name",
            "customer_name",
            "shipper_locality",
            "shipper_region",
            "consignee_locality",
            "consignee_region",
            "load_start",
            "load_end",
            "appointment_required",
            "appointment_start",
            "appointment_end",
            "trip_number",
            "drop_trailer",
            "partial_or_full",
            "load_pallets",
            "load_pieces",
            "load_length",
            "load_length_unit",
            "load_weight",
            "load_weight_actual",
            "load_weight_unit",
            "type_of_equipment",
            "lading_id",
            "drop_trailer_status",
            "expedited",
            "customer_po",
            "pickup_reference_number",
            "delivery_reference_number",
            "booking_number",
            "release_number",
            "equipment_options",
            "created"
        ]
    }
}